'use es6';

import emptyFunction from 'react-utils/emptyFunction';
import { uniqueId } from 'underscore';
export const copyToClipboard = ({
  text,
  onSuccess = emptyFunction,
  onFail = emptyFunction
}) => {
  const textArea = document.createElement('textarea');
  document.body.appendChild(textArea);
  textArea.value = text;
  textArea.select();

  try {
    const success = document.execCommand('copy');

    if (success) {
      onSuccess();
    } else {
      onFail();
    }
  } catch (e) {
    onFail();
    throw new Error('Copy will not work for this user');
  }

  document.body.removeChild(textArea);
};
export const getModuleSnippet = ({
  moduleId,
  name,
  path
}) => {
  const snippetName = uniqueId(`module_${Date.now()}`);

  if (path) {
    return `{% module "${snippetName}" path="${path}", label="${name}" %}`;
  }

  return `{% module "${snippetName}" module_id="${moduleId}", label="${name}" %}`;
};